// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "-" + {"12":"90fa3024","175":"0d370a93","233":"7fbff527","369":"ca7b6592","777":"d85915b3","936":"229b2271"}[chunkId] + ".js";
};